define(
({
	loadingState: "Caricamento in corso...",
	errorState: "Si è verificato un errore"
})
);
